<script>
  import notify from "../../../../Script/notify"
  import Field from "./field.svelte"
  export let parent = ""

  export let fields = []
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  const handleFieldAddition = () => {
    try {
      let currentFields = fields.filter((field) => field.parent == parent) || []

      if (currentFields.length != 0) {
        let finalEntry = currentFields[currentFields.length - 1]

        let key = finalEntry.key.trim()
        let value = finalEntry.value.trim()

        if (!key) {
          document.querySelector(`#key${finalEntry.id}`)?.focus()
          throw "Kindly enter a value for key"
        }

        if (!value) throw `Kindly enter a value for field named as ${key}`
      }

      const newField = {}
      newField.id = Math.round(Date.now() + Math.random() * 10000 + 1)
      newField.parent = parent
      newField.key = ""
      newField.value = ""

      fields = [...fields, newField]
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Edit Document Metadata (Single Publish)\nEVENT: While adding new metadata field"
      closeNotification = notify.danger(error, info)
    }
  }

  const handleDeletion = (id, key) => {
    try {
      closeNotification.close()
      key = key.trim()
      fields = fields.filter((field) => field.id != id)

      closeNotification = notify.info(`${!key ? "Empty Key value" : key}  pair deleted successfully.`)
    } catch (error) {
      console.error(error)
      const info = "PAGE: Edit Document Metadata (Single Publish)\nEVENT: While deleting metadata field"
      closeNotification = notify.danger(error, info)
    }
  }

  const handleSameKeyCheck = (id, key) => {
    try {
      closeNotification.close()
      key = key.trim()

      if (!key) return

      let currentFields = fields.filter((field) => field.parent == parent && field.id != id) || []

      if (currentFields.length != 0) {
        let keyArr = currentFields.map((field) => field.key)

        // console.log(keyArr)

        if (keyArr.includes(key)) {
          fields = fields.filter((field) => field.id != id)
          throw "Same key not allowed."
        }
      } else {
        if ((parent == "receiver" && key == "name") || (parent == "document" && key == "type") || (parent == "issuer" && key == "signatory")) {
          fields = fields.filter((field) => field.id != id)
          throw "Same key not allowed."
        }
      }
    } catch (error) {
      console.error(error)
      const info = "PAGE: Edit Document Metadata (Single Publish)\nEVENT: Duplicate metadata key check on input blur"
      closeNotification = notify.danger(error, info)
    }
  }
</script>

{#each fields.filter((field) => field.parent == parent) as field (field.id)}
  <Field
    bind:field
    on:click={() => {
      handleDeletion(field.id, field.key)
    }}
    on:blur={() => {
      handleSameKeyCheck(field.id, field.key)
    }}
  />
{/each}

<button on:click={handleFieldAddition} type="button" class="mx-auto mt-3 flex h-9 w-32 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none focus-visible:bg-green-600 active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-300 lg:px-4">
  <span>
    <i class="fa-solid fa-plus" />
  </span>
  <span class="block select-none">&nbsp;Add Field&nbsp;</span>
</button>
